import { escapeHtml } from "../../ui/text.ts";

const decisions: Record<string, string> = {
  keep: "left unchanged", defer: "set aside for a later review", schedule: "deadlines changed", move: "moved",
  prioritize: "priorities changed", assign: "assignments changed", complete: "completed", archive: "archived", delete: "moved to Trash",
};

export function reviewDecisionSummary(reviewed: number, actions: Record<string, string> = {}): string {
  const counts = new Map<string, number>();
  for (const action of Object.values(actions)) if (decisions[action]) counts.set(action, (counts.get(action) || 0) + 1);
  return `<p>${reviewed} ${reviewed === 1 ? "task" : "tasks"} reviewed.</p>${counts.size ? `<ul class="review-decisions">${[...counts].map(([action, count]) => `<li><strong>${count}</strong> ${decisions[action]}</li>`).join("")}</ul>` : ""}<p class="review-hint">Review progress is private to this device. Only explicit task changes are shared with collaborators.</p>`;
}

export function reviewGroupButton(key: string, label: string, count: number, attribute = "data-review-start"): string {
  return `<button type="button" class="review-group-button" ${attribute}="${escapeHtml(key)}" ${count ? "" : "disabled"}><span>${escapeHtml(label)}</span><strong>${count}</strong></button>`;
}

export function reviewErrorView(): string {
  return '<p class="review-error" role="alert" hidden></p>';
}

export function preserveReviewContent(dialog: HTMLElement, html: string): void {
  const toasts = dialog.querySelector(".dialog-toast-region");
  dialog.innerHTML = html;
  if (toasts) dialog.append(toasts);
}
